/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The mode of security:
 *   * NONE
 *   * SIGN
 *   * SIGN_ENCRYPT
 */
export enum SecurityMode {
  NONE = 'NONE',
  SIGN = 'SIGN',
  SIGN_ENCRYPT = 'SIGN_ENCRYPT'
}
